<template>
  <AdjustmentCommonLayout header="controlHeader" footer="controlFooter">
    <b-overlay :show="overlayShow" rounded="sm">
      <div class="container" style="max-width: 3420px;">
        <div id="search-box" class="row mt-3 base-color">
          <div class="accordion col p-0" role="tablist2">
            <b-card no-body style="overflow: visible !important;">
              <b-card-header header-tag="header" class="p-0" role="tab">
                <b-button block v-b-toggle.accordion-2 id='search-bar' class="light-blue text-left text-black" @click="changeIcon(2)"><b-icon id="icon-up_2" icon="chevron-up"></b-icon><b-icon id="icon-down_2" class="hide" icon="chevron-down"></b-icon>&nbsp;集約対象検索条件</b-button>
              </b-card-header>
              <!-- 検索BOX -->
              <b-collapse visible id="accordion-2" accordion="my-accordion2" role="tabpane2">
                <b-card-body>
                  <form method="post" action="#" class="form-horizontal">
                    <div class="form-group row">
                      <div class="col-sm-3 pr-0">
                        <div class="row" style="margin-left: 0px">
                          <label class="control-label col-sm-12">予約期間</label>
                          <div class="col-sm-5 pr-0">
                            <input type="date" id="main-price-from" class="form-control input-sm search-spec-condition" v-model="searchDateFrom"/>
                          </div>
                          <div class="col-sm-1 p-0 mt-2 text-center">
                            <span>〜</span>
                          </div>
                          <div class="col-sm-5 pl-0">
                            <input type="date" id="main-price-to" class="form-control input-sm search-spec-condition" v-model="searchDateTo"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-3 row">
                        <label for="spec-facility" class="control-label col-sm-12">施設</label>
                        <div class="col-sm-12 px-0">
                          <div class="col-sm-12 pr-0">
                            <select id="spec-facility" class="form-control input-sm search-condition" v-model="searchFacilityCode" label="label" :options="facilityData">
                              <option v-for="facilityInfo in facilityData" :key="facilityInfo['施設コード']['value']" :value="facilityInfo['施設コード']['value']">
                                {{facilityInfo['施設名']['value']}}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-2">
                        <label for="equipment-name" class="control-label col-sm-12">器材名</label>
                        <div class="col-sm-12 pr-0">
                          <input type="text" id="equipment-name" class="form-control input-sm search-spec-condition" v-model="searchEquipmentName"/>
                        </div>
                      </div>
                    </div>
                    <div class="text-center mt-4">
                      <b-button variant="outline-secondary" type="button" class="w-25 white-btn" @click="clearConditions">検索条件をクリア</b-button>
                      <b-button class="main-color text-light w-25 ml-3" @click="searchReservationInfo()">検索</b-button>
                    </div>
                    <div v-if="isFilterActive">
                      <div class="form-group row mt-5">
                        <div class="col-sm-2">
                          <label for="delivery-location" class="control-label col-sm-12">納品場所</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="delivery-location" class="input-sm search-spec-condition" v-model="searchDeliveryLocation" :options="deliveryLocationData" :value="searchDeliveryLocation" name="deliveryLocation" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                            </v-select>
                            <!-- <input type="text" id="delivery-location" class="form-control input-sm search-spec-condition" v-model="searchDeliveryLocation"/> -->
                          </div>
                        </div>
                        <div class="col-sm-2">
                          <label for="storage-location" class="control-label col-sm-12">保管場所</label>
                          <div class="col-sm-12 pr-0">
                            <v-select id="storage-location" class="input-sm search-spec-condition" v-model="searchStorageLocation" :options="storageLocationData" :value="searchStorageLocation" name="storageLocation" :close-on-select="false" :deselectFromDropdown="true" append-to-body multiple>
                            </v-select>
                            <!-- <input type="text" id="storage-location" class="form-control input-sm search-spec-condition" v-model="searchStorageLocation"/> -->
                          </div>
                        </div>
                      </div>
                      <div class="text-left mt-4">
                        <b-button class="main-color text-light w-10 ml-3" @click="filterReservationInfo()">絞り込む</b-button>
                      </div>
                    </div>
                  </form>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>

        <!-- 資器材一覧リスト -->
        <div class="row mt-3 base-color">
          <b-overlay :show="overlayEquipmentListShow" rounded="sm" class="col-sm-12">
            <div class="col-sm-12 row pt-3 pr-0">
              <div class="col-sm-10 text-left pr-0">
                {{nowConditionsText}}
              </div>
              <div class="col-sm-2 text-right pr-0">
                <b-button variant="primary" @click="checkNoReservationData" :disabled="!reservationPossible">予約更新</b-button>
              </div>
            </div>
            <div class="card-deck customer-img-col-cnt" style="width:100%;">
              <div v-for="(material, index) in materialList" :key="index" style="display:inline-block; width:33%; vertical-align: top;" :class="{'mt-5': index > 2}">
                <div class="col-sm-12 mt-3 mb-1">
                  <span class="col-12 p-0" style="font-size: large; font-weight: bold;" :style="{color: ('checkFlag' in material && !material['checkFlag']) ? 'red' : ''}">{{material['materialName']}}</span>
                </div>

                  <div class="col-12 row pr-0">
                    <div class="col-sm-6 mt-3">
                      <div class="col-12 row pr-0">
                        <span class="col-6 p-0">予約数合計</span>
                        <span class="col-6 p-0 text-right">{{material['totalReservationNumber']}}</span>
                      </div>
                      <div class="border-bottom col-12"></div>
                    </div>
                    <div class="col-sm-6 mt-3">
                      <b-table-simple bordered class="small" style="padding: .1rem">
                        <thead role="rowgroup" class="table-bordered">
                          <tr role="row" class="align-middle">
                            <th rowspan="1" class="align-middle text-center" style="width: 50%; padding: 0.1rem;">使用日</th>
                            <th rowspan="1" class="align-middle text-center" style="width: 50%; padding: 0.1rem;">使用数</th>
                          </tr>
                        </thead>
                        <template v-for="(info, index) in material['useInfo']">
                          <b-tbody :key="index + 'tbody'" :class="index % 2 === 1 ? 'gray-line' : 'white-line'">
                            <b-tr :key="index + 'activeProject'">
                              <b-td class="align-middle" style="padding: 0.1rem;">{{info['useDate'] + '&nbsp;' + info['dayOfWeekConstruction']}}</b-td>
                              <b-td class="align-middle" style="padding: 0.1rem;"><p @click="openProjectInfoModal(info['projectInfo'])" style="cursor:pointer; margin-top:0; margin-bottom:0;" class="text-right">{{info['totalUseNumber']}}</p></b-td>
                            </b-tr>
                          </b-tbody>
                        </template>
                      </b-table-simple>
                    </div>
                  </div>
                  <div class="col-sm-12 mt-3" style="overflow-y: scroll; max-height: 370px;">
                    <b-table-simple bordered class="small fixed-header-table" style="padding: .1rem">
                      <thead role="rowgroup" class="table-bordered">
                        <tr role="row" class="align-middle">
                          <th rowspan="1" class="align-middle text-center" style="width: 3%; padding: 0.1rem;"></th>
                          <th rowspan="1" class="align-middle text-center" style="width: 10%; padding: 0.1rem;" >管理番号</th>
                          <th rowspan="1" class="align-middle text-center" style="width: 12%; padding: 0.1rem;" >ロット数</th>
                          <th rowspan="1" class="align-middle text-center" style="width: 35%; padding: 0.1rem;" >保管場所</th>
                          <th rowspan="1" class="align-middle text-center" style="width: 40%; padding: 0.1rem;" >納品場所</th>
                        </tr>
                      </thead>
                      <template v-for="(lendInfo, rowIndex) in material['lendList']">
                        <b-tbody :key="rowIndex + 'tbody'" :class="lendInfo['lendFlag'] && (lendInfo['lendDate'] !== nowSearchDateFrom || lendInfo['returnDate'] !== nowSearchDateTo) ? 'disabled-line' : rowIndex % 2 === 1 ? 'gray-line' : 'white-line'">
                          <b-tr :key="rowIndex + 'activeProject'">
                            <b-td class="align-middle"><input name="checkbox" type="checkbox" :checked="lendInfo['lendFlag']" v-model="lendInfo['lendFlag']" @change="setRowEdit(index, rowIndex, false)" :disabled="lendInfo['lendFlag'] && (lendInfo['lendDate'] !== nowSearchDateFrom || lendInfo['returnDate'] !== nowSearchDateTo)"></b-td>
                            <b-td class="align-middle" style="padding: 0.1rem;">{{lendInfo['managementNumber']}}</b-td>
                            <b-td class="align-middle text-center" style="padding: 0.1rem;">{{lendInfo['lotNumber']}}</b-td>
                            <b-td class="align-middle" style="padding: 0.1rem;">{{lendInfo['storageLocation']}}</b-td>
                            <b-td class="align-middle" style="padding: 0.1rem;">
                              <select id="spec-facility" class="form-control input-sm search-condition" v-model="lendInfo['deliveryLocation']" @change="setRowEdit(index, rowIndex, true)" label="label" :options="material['deliveryLocationList']" :disabled="lendInfo['lendFlag'] && (lendInfo['lendDate'] !== nowSearchDateFrom || lendInfo['returnDate'] !== nowSearchDateTo)">
                                <option v-for="(deliveryLocationName, i) in material['deliveryLocationList']" :key="i" :value="deliveryLocationName">
                                  {{deliveryLocationName}}
                                </option>
                              </select>
                            </b-td>
                          </b-tr>
                        </b-tbody>
                      </template>
                    </b-table-simple>
                  </div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </b-overlay>
    <CommonModal ref="commonModal" />
    <CommonModal ref="commonModalNoRegistrationCheck" @confirmOk="checkChangedData" />
    <CommonModal ref="commonModalRegistrationCheck" @confirmOk="updateReservation" />
    <ProjectInfoModal ref="projectInfoModal" />
  </AdjustmentCommonLayout>
</template>
<script>
import AdjustmentCommonLayout from '@/layout/AdjustmentCommonLayout'
import CommonModal from '@/components/CommonModal'
import SearchMaterialsAndEquipmentModel from '@/models/SearchMaterialsAndEquipmentModel'
import ConvibaseProductModel from '@/models/ConvibaseProductModel'
import UpdateMaterialsAndEquipmentModel from '@/models/UpdateMaterialsAndEquipmentModel'
import FacilityListModel from '@/models/FacilityListModel'
import ProjectInfoModal from '@/components/ProjectInfoModal'
import Vue from 'vue'
import Paginate from 'vuejs-paginate'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('paginate', Paginate)
Vue.component('v-select', vSelect)

export default {
  name: 'MaterialsAndEquipmentAdjustmentList',
  components: { AdjustmentCommonLayout, CommonModal, FacilityListModel, SearchMaterialsAndEquipmentModel, ProjectInfoModal },
  data () {
    return {
      overlayShow: false,
      overlayEquipmentListShow: false,
      searchEquipmentName: '',
      searchDeliveryLocation: [],
      searchStorageLocation: [],
      searchDateFrom: '',
      searchDateTo: '',
      facilityData: [],
      storageLocationData: [],
      deliveryLocationData: [],

      nowSearchEquipmentName: '',
      nowSearchDeliveryLocation: '',
      nowSearchStorageLocation: '',
      nowSearchDateFrom: '',
      nowSearchDateTo: '',
      nowSearchFacilityName: '',

      activeProjectList: [],
      searchData: [],
      searchDataBk: [],
      searchFacilityCode: '',
      searchDataSetFlg: false,

      nowSearchFacilityCode: '',
      nowFacilityData: [],
      reservationPossible: false,
      prodBaseCode: '',
      nowConditionsText: '',

      materialList: [],

      isFilterActive: false,
      isInitializing: true,
      pastDate: false
    }
  },
  methods: {
    setApiData: async function (isReload = false) {
      this.overlayShow = true
      console.log(this.$route.query)

      // パラメータの制作拠点コードから施設を取得(検索条件の一覧作成の為)
      this.prodBaseCode = this.$route.query.prodBaseCode
      let params = {'prodBaseCode': this.prodBaseCode}
      // プルダウン内容設定
      let facilityData = await FacilityListModel.getApi(this.$bvModal, params)
      this.facilityData = facilityData['facilities']['records']
      this.overlayShow = false
    },
    changeIcon (num) {
      document.getElementById('icon-up_' + num).classList.toggle('hide')
      document.getElementById('icon-down_' + num).classList.toggle('hide')
    },
    validate () {
      // 検索条件のチェックを追加する
      if (this.searchDateFrom === '' || this.searchDateTo === '') {
        this.$bvModal.msgBoxOk('予約期間を入力してください。')
        return false
      }
      if (this.searchFacilityCode === '') {
        this.$bvModal.msgBoxOk('施設を入力してください。')
        return false
      }

      var today = new Date()
      // 予約開始日 火曜日チェック
      var dateFromThu = new Date(this.searchDateFrom)
      var dateFromDayOfWeek = dateFromThu.getDay()
      if (dateFromDayOfWeek !== 2) {
        this.$bvModal.msgBoxOk('予約開始日には火曜日の日付を入力してください。')
        return false
      }
      // 予約終了日 火曜日チェック
      var dateToThu = new Date(this.searchDateTo)
      var dateTodayOfWeek = dateToThu.getDay()
      if (dateTodayOfWeek !== 2) {
        this.$bvModal.msgBoxOk('予約終了日には火曜日の日付を入力してください。')
        return false
      }

      // 予約開始日～予約終了日 大小チェック
      if (dateFromThu >= dateToThu) {
        this.$bvModal.msgBoxOk('予約終了日には予約開始日より未来の日付を入力してください。')
        return false
      }

      // 今日の日付から5日後以前の日付を予約開始日に設定した場合「予約更新」ボタンを押下出来なくする
      this.pastDate = false
      const limitDate = new Date()
      limitDate.setDate(today.getDate() + 5)
      const targetDate = new Date(dateFromThu)
      if (targetDate <= limitDate) {
        this.pastDate = true
      }
      return true
    },
    clearConditions () {
      this.searchEquipmentName = ''
      // this.searchDeliveryLocation = ''
      // this.searchStorageLocation = ''
      this.searchDateFrom = ''
      this.searchDateTo = ''
      this.searchFacilityCode = ''
    },
    searchReservationInfo: async function () {
      // 画面入力値のチェックを行う
      if (await !this.validate()) {
        return false
      }
      this.overlayEquipmentListShow = true

      let params = {}
      this.materialList = []
      this.storageLocationData = []
      this.deliveryLocationData = []

      if (this.searchEquipmentName !== '') {
        params['equipmentName'] = this.searchEquipmentName
      }
      /* if (this.searchDeliveryLocation !== '') {
        params['deliveryLocation'] = this.searchDeliveryLocation
        this.reservationPossible = false
      }
      if (this.searchStorageLocation !== '') {
        params['storageLocation'] = this.searchStorageLocation
        this.reservationPossible = false
      } */
      if (this.searchDateFrom !== '') {
        params['dateFrom'] = this.searchDateFrom
      }
      if (this.searchDateTo !== '') {
        params['dateTo'] = this.searchDateTo
      }

      params['searchFacilityCode'] = this.searchFacilityCode
      params['prodBaseCode'] = this.prodBaseCode

      let searchData = await SearchMaterialsAndEquipmentModel.getApi(this.$bvModal, params, () => {})
      console.log(searchData)
      if (searchData['status'] !== 'success') {
        console.log('資器材予約情報検索失敗')
        this.overlayEquipmentListShow = false
        return false
      }
      if (!('materialCodeList' in searchData) || ('materialCodeList' in searchData && searchData['materialCodeList'].length === 0) || this.pastDate) {
        this.reservationPossible = false
      } else {
        this.reservationPossible = true
      }
      // Convi.BASEの物品情報を取得
      let productResult = ''
      if ('materialCodeList' in searchData) {
        for (let i = 0; i < searchData['materialCodeList'].length; i++) {
          params['materialCode'] = searchData['materialCodeList'][i]
          params['managementNumberList'] = searchData['managementNumberList'][searchData['materialCodeList'][i]]

          productResult = await ConvibaseProductModel.getApi(this.$bvModal, params, () => {})
          let response = {}
          response.materialList = []
          let deliveryLocationList = productResult['deliveryLocationList']
          this.deliveryLocationData = productResult['deliveryLocationList']
          let lendResult = searchData['lendResult']
          // 計上部署コード
          let departmentCode = productResult['departmentCode']
          // 案件番号リスト
          let caseNumberList = []
          // 打合せ参加IDリスト
          let projectNumberList = []

          // 取得した貸し出し情報と物品テーブル情報を紐づける
          for (const productData of productResult.productInfo.view.items) {
            // 商材コード
            let materialCode = ''
            // 商材名
            let materialName = ''
            // 貸し出しフラグ
            let lendFlag = false
            // 管理番号
            let managementNumber = ''
            // ロット数
            let lotNumber = ''
            // 保管場所
            let storageLocation = ''
            // 納品場所
            let deliveryLocation = ''
            // 保管場所(貸し出し)
            let lendStorageLocation = ''
            // 納品場所(貸し出し)
            let lendDeliveryLocation = ''
            // 貸し出し状況
            let lendStatus = ''
            // 物品ID
            let goodsId = productData.id
            // 貸し出しID
            let lendId = ''
            // 貸出し日
            let lendDate = ''
            // 返却予定日
            let returnDate = ''

            for (const productInfo of productData.cells) {
              // 商材コード
              if (productInfo.columnId === 't33_c107' && productInfo.value) {
                materialCode = productInfo.value
              }
              // 商材名
              if (productInfo.columnId === 't33_c2' && productInfo.value) {
                materialName = productInfo.value
              }
              // 貸し出し状況
              if (productInfo.columnId === 't33_c133' && productInfo.value) {
                lendStatus = productInfo.value
              }
              // 管理番号で紐づける
              if (productInfo.columnId === 't33_c1' && productInfo.value) {
                managementNumber = productInfo.value
                for (const lendData of lendResult.view.items) {
                  if (lendFlag) break

                  for (const lendInfo of lendData.cells) {
                    if (lendInfo.columnId === 't90_c2' && lendInfo.value) {
                      if (managementNumber === lendInfo.value) {
                        lendFlag = true
                        // 貸し出しID
                        lendId = lendData.id
                      }
                    }
                    // 保管場所（貸し出し）
                    if (lendInfo.columnId === 't90_c139' && lendInfo.value) {
                      lendStorageLocation = lendInfo.value
                    }
                    // 納品場所（貸し出し）
                    // 案件番号リスト
                    // 打合せ参加IDリスト
                    if (lendInfo.columnId === 't90_c7' && lendInfo.value) {
                      const memoList = lendInfo.value.split('/')
                      if (memoList.length > 1) {
                        lendDeliveryLocation = memoList[1]
                      }
                      if (memoList.length > 6) {
                        if (caseNumberList.indexOf(memoList[6]) === -1) {
                          caseNumberList.push(memoList[6])
                        }
                      }
                      if (memoList.length > 5) {
                        if (projectNumberList.indexOf(memoList[5]) === -1) {
                          projectNumberList.push(memoList[5])
                        }
                      }
                    }
                    // 貸出し日
                    if (lendInfo.columnId === 't90_c5' && lendInfo.value) {
                      lendDate = lendInfo.value.split('T')[0]
                      // 火曜日に戻す為、貸出し日を-1日とする
                      lendDate = this.shiftDate(lendDate, -1)
                    }
                    // 返却予定日
                    if (lendInfo.columnId === 't90_c8' && lendInfo.value) {
                      returnDate = lendInfo.value.replace(/\//g, '-')
                      // 火曜日に戻す為、返却予定日を+1日とする
                      returnDate = this.shiftDate(returnDate, +1)
                    }
                  }
                }
              }
              // ロット数
              if (productInfo.columnId === 't33_c110' && productInfo.value) {
                lotNumber = productInfo.value
              }
              // 保管場所
              if (productInfo.columnId === 't33_c119' && productInfo.value) {
                storageLocation = productInfo.value
              }
              // 納品場所（施設マスタの先頭）
              deliveryLocation = deliveryLocationList[0]
            }

            // 予約済みでなく、貸出し状況が「メンテ中」または、ロット数が0の場合は表示しない
            if (!lendFlag && (lendStatus === 'メンテ中' || lotNumber === '0')) {
              continue
            }

            // 予約済みでなく、今日の日付から5日後以前の日付を予約開始日に設定した場合は表示しない
            if (!lendFlag && this.pastDate) {
              continue
            }

            if (response.materialList.length > 0) {
              let found = false

              for (const materialInfo of response.materialList) {
                if (materialInfo.materialCode === materialCode) {
                  found = true

                  if (lendFlag) {
                    materialInfo.totalReservationNumber = Number(materialInfo.totalReservationNumber) + Number(lotNumber)
                  }

                  materialInfo.lendList.push({
                    edit: false,
                    lendFlag: lendFlag,
                    managementNumber: managementNumber,
                    lotNumber: lotNumber,
                    storageLocation: lendFlag ? lendStorageLocation : storageLocation,
                    deliveryLocation: lendFlag ? lendDeliveryLocation : deliveryLocation,
                    lendId: lendId,
                    goodsId: goodsId,
                    lendDate: lendDate,
                    returnDate: returnDate
                  })
                  break
                }
              }

              if (!found) {
                response.materialList.push({
                  materialCode: materialCode,
                  materialName: materialName,
                  totalReservationNumber: lendFlag ? lotNumber : 0,
                  lendList: [{
                    edit: false,
                    lendFlag: lendFlag,
                    managementNumber: managementNumber,
                    lotNumber: lotNumber,
                    storageLocation: lendFlag ? lendStorageLocation : storageLocation,
                    deliveryLocation: lendFlag ? lendDeliveryLocation : deliveryLocation,
                    lendId: lendId,
                    goodsId: goodsId,
                    lendDate: lendDate,
                    returnDate: returnDate
                  }],
                  deliveryLocationList: deliveryLocationList,
                  departmentCode: departmentCode,
                  caseNumberList: caseNumberList,
                  projectNumberList: projectNumberList
                })
              }
            } else {
              response.materialList.push({
                materialCode: materialCode,
                materialName: materialName,
                totalReservationNumber: lendFlag ? lotNumber : 0,
                lendList: [{
                  edit: false,
                  lendFlag: lendFlag,
                  managementNumber: managementNumber,
                  lotNumber: lotNumber,
                  storageLocation: lendFlag ? lendStorageLocation : storageLocation,
                  deliveryLocation: lendFlag ? lendDeliveryLocation : deliveryLocation,
                  lendId: lendId,
                  goodsId: goodsId,
                  lendDate: lendDate,
                  returnDate: returnDate
                }],
                deliveryLocationList: deliveryLocationList,
                departmentCode: departmentCode,
                caseNumberList: caseNumberList,
                projectNumberList: projectNumberList
              })
            }
            let storageLocationOption = lendFlag ? lendStorageLocation : storageLocation
            if (!this.storageLocationData.includes(storageLocationOption)) {
              this.storageLocationData.push(storageLocationOption)
            }
          }
          this.materialList.push(response['materialList'][0])
        }
        const today = new Date()
        for (const matInfo of this.materialList) {
          let dates = []
          if (matInfo['materialCode'] in searchData['useInfo']) {
            matInfo['useInfo'] = searchData['useInfo'][matInfo['materialCode']]
            for (const useData of matInfo['useInfo']) {
              if ('useDate' in useData && !(useData['useDate'] in dates)) {
                dates.push(useData['useDate'])
              }
            }
          }
          // 直近の施行日を設定する
          let minDiff = Infinity
          let closestDate = ''
          dates.forEach(dateStr => {
            const targetDate = new Date(dateStr)
            // 日付の差を計算（ミリ秒）
            const diff = Math.abs(today - targetDate)
            if (diff < minDiff) {
              minDiff = diff
              closestDate = dateStr
            }
          })
          console.log('直近の施行日:', closestDate)
          matInfo['constructionDate'] = closestDate
        }
      }
      console.log(this.materialList)
      this.searchData = productResult['productInfo']

      if (this.materialList.length > 0) {
        this.isFilterActive = true
      }
      // バックアップを保存
      // this.searchDataBk = []
      // for (let i = 0; i < this.materialList.length; i++) {
      //  let defdata = Object.assign({}, JSON.parse(JSON.stringify(this.materialList[i])))
      //  this.searchDataBk.push(defdata)
      // }
      this.searchDataBk = JSON.parse(JSON.stringify(this.materialList))
      this.isInitializing = false

      // 検索条件の状態を更新する
      this.nowSearchEquipmentName = this.searchEquipmentName
      // this.nowSearchDeliveryLocation = this.searchDeliveryLocation
      // this.nowSearchStorageLocation = this.searchStorageLocation
      this.nowSearchDateFrom = this.searchDateFrom
      this.nowSearchDateTo = this.searchDateTo
      this.nowSearchFacilityCode = this.searchFacilityCode
      for (let i = 0; i < this.facilityData.length; i++) {
        if (this.facilityData[i]['施設コード']['value'] === this.searchFacilityCode) {
          this.nowSearchFacilityName = this.facilityData[i]['施設名']['value']
        }
      }
      this.overlayEquipmentListShow = false

      this.nowConditionsText = '現在の適用検索条件:'
      if (this.nowSearchDateFrom && this.nowSearchDateTo) {
        let reservationPeriodText = '（予約期間）' + this.nowSearchDateFrom + '~' + this.nowSearchDateTo
        this.nowConditionsText += reservationPeriodText
      }

      if (this.nowSearchFacilityName) {
        let facilityText = '（施設）' + this.nowSearchFacilityName
        this.nowConditionsText += facilityText
      }

      if (this.nowSearchEquipmentName) {
        let equipmentNameText = '（器材名）' + this.nowSearchEquipmentName
        this.nowConditionsText += equipmentNameText
      }

      /* if (this.nowSearchDeliveryLocation) {
        let deliveryLocationText = '（納品場所）' + this.nowSearchDeliveryLocation
        this.nowConditionsText += deliveryLocationText
      }

      if (this.nowSearchStorageLocation) {
        let storageLocationText = '（保管場所）' + this.nowSearchStorageLocation
        this.nowConditionsText += storageLocationText
      } */
    },
    updateReservation: async function () {
      this.overlayEquipmentListShow = true
      console.log(this.materialList)
      let registData = {}
      registData['prodBaseCode'] = this.prodBaseCode
      registData['dateFrom'] = this.nowSearchDateFrom
      registData['dateTo'] = this.nowSearchDateTo
      registData['facilityCode'] = this.nowSearchFacilityCode
      registData['facilityName'] = this.nowSearchFacilityName
      for (let i = 0; i < this.materialList.length; i++) {
        registData['registData'] = []
        registData['materialCode'] = this.materialList[i]['materialCode']
        registData['materialName'] = this.materialList[i]['materialName']
        registData['departmentCode'] = this.materialList[i]['departmentCode']
        registData['caseNumberList'] = this.materialList[i]['caseNumberList']
        registData['projectNumberList'] = this.materialList[i]['projectNumberList']
        registData['constructionDate'] = this.materialList[i]['constructionDate']
        for (let t = 0; t < this.materialList[i]['lendList'].length; t++) {
          if (!this.materialList[i]['lendList'][t]['edit'] || (this.materialList[i]['lendList'][t]['edit'] && this.materialList[i]['lendList'][t]['lendId'] === '' && !this.materialList[i]['lendList'][t]['lendFlag'])) {
            // 編集行ではないまたは、編集行だが元々予約無し行で貸出しチェックボックスがONになっていない行(納品場所のみ変更した行)は飛ばす
            continue
          }
          registData['registData'].push(this.materialList[i]['lendList'][t])
        }
        if (registData['registData'].length === 0) {
          // 更新データが無ければ飛ばす
          continue
        }
        // 予約更新処理
        await UpdateMaterialsAndEquipmentModel.apiSetStore(this.$bvModal, registData, () => {})
      }

      // 更新が終了したら、画面も同じ検索条件で検索し、画面更新をする
      this.searchEquipmentName = this.nowSearchEquipmentName
      // this.searchDeliveryLocation = this.nowSearchDeliveryLocation
      // this.searchStorageLocation = this.nowSearchStorageLocation
      this.searchDateFrom = this.nowSearchDateFrom
      this.searchDateTo = this.nowSearchDateTo

      await this.searchReservationInfo()
      this.$bvModal.msgBoxOk('器材予約が完了しました。')
      this.overlayEquipmentListShow = false
    },
    checkNoReservationData () {
      let noReservationText = ''
      for (let i = 0; i < this.materialList.length; i++) {
        if ('checkFlag' in this.materialList[i] && !this.materialList[i]['checkFlag']) {
          noReservationText = noReservationText + '「' + this.materialList[i]['materialName'] + '」\n'
        }
      }
      if (noReservationText) {
        this.$refs.commonModalNoRegistrationCheck.msgBoxConfirm(noReservationText + 'の器材予約がチェックされていません。\n' + '該当の予約をすべて解除してよろしいですか？')
      } else {
        this.checkChangedData()
      }
    },
    checkChangedData () {
      // 検索・保存時のデータと入力後のデータを比較する。
      // 一致していなければ編集あり。
      let newstr = JSON.stringify(this.materialList)
      let oldstr = JSON.stringify(this.searchDataBk)

      if (newstr !== oldstr) {
        this.$refs.commonModalRegistrationCheck.msgBoxConfirm('Convi.BASEに器材予約を登録します。登録後は、案件情報から器材予約の追加・変更はできません。\nよろしいですか？')
      } else {
        this.$bvModal.msgBoxOk('連携対象がありません。')
        return false
      }
    },
    setRowEdit (index, rowIndex, deliveryLocation) {
      // 検索・保存時のデータと入力後のデータを比較する。
      // 一致していなければ編集あり。

      // let newstr = JSON.stringify(this.materialList[index]['lendList'][rowIndex])
      // let oldstr = JSON.stringify(this.searchDataBk[index]['lendList'][rowIndex])

      let editFlag = false

      if (deliveryLocation) {
        // 納品場所を変更した場合
        if (this.materialList[index]['lendList'][rowIndex]['deliveryLocation'] !== this.searchDataBk[index]['lendList'][rowIndex]['deliveryLocation']) {
          editFlag = true
        } else {
          editFlag = false
        }
      } else {
        // 貸出しチェックボックスを変更した場合
        if (this.materialList[index]['lendList'][rowIndex]['lendFlag'] !== this.searchDataBk[index]['lendList'][rowIndex]['lendFlag']) {
          editFlag = true
        } else {
          editFlag = false
        }

        // 他の管理番号の商材を含めて全てチェックが外れたかどうか確認する
        let breakFlag = false
        for (let i = 0; i < this.materialList[index]['lendList'].length; i++) {
          if (this.materialList[index]['lendList'][i]['lendFlag']) {
            this.materialList[index]['checkFlag'] = true
            breakFlag = true
            break
          }
        }
        if (!breakFlag) {
          this.materialList[index]['checkFlag'] = false
        }
      }
      this.materialList[index]['lendList'][rowIndex]['edit'] = editFlag
    },
    openProjectInfoModal (projectInfo) {
      this.$refs.projectInfoModal.showModal(projectInfo)
    },
    shiftDate (dateStr, diffDays) {
      const [y, m, d] = dateStr.split('-').map(Number)
      const date = new Date(y, m - 1, d + diffDays)

      return `${date.getFullYear()}-${
        String(date.getMonth() + 1).padStart(2, '0')
      }-${
        String(date.getDate()).padStart(2, '0')
      }`
    },
    filterReservationInfo () {
      this.overlayEquipmentListShow = true
      let filteredMaterialList = JSON.parse(JSON.stringify(this.searchDataBk))
      if (this.searchStorageLocation.length > 0 || this.searchDeliveryLocation.length > 0) {
        for (const info of filteredMaterialList) {
          for (let i = info['lendList'].length - 1; i >= 0; i--) {
            let deleteFlag = false
            if (this.searchStorageLocation.length > 0 && !this.searchStorageLocation.includes(info['lendList'][i]['storageLocation'])) {
              info['lendList'].splice(i, 1)
              deleteFlag = true
            }
            if (!deleteFlag && this.searchDeliveryLocation.length > 0 && !this.searchDeliveryLocation.includes(info['lendList'][i]['deliveryLocation'])) {
              info['lendList'].splice(i, 1)
              deleteFlag = true
            }
          }
        }
        this.reservationPossible = false
        this.materialList = filteredMaterialList
      } else {
        // 絞り込み条件がない場合、元の検索結果に戻す
        this.materialList = JSON.parse(JSON.stringify(this.searchDataBk))
      }
      this.overlayEquipmentListShow = false
    }
  },
  mounted: async function () {
    document.title = '資器材回し用一覧'
    if (process.env.APP_ENV !== 'production') {
      document.title = '【テスト環境】資器材回し用一覧'
    }
    await this.setApiData()
  }
  /** watch: {
    materialList: {
      deep: true,
      handler (newList, oldList) {
        if (this.isInitializing) return
        newList.forEach((material, index) => {
          material.lendList.forEach((lend, rowIndex) => {
            const oldLend = oldList[index].lendList[rowIndex]
            if (!oldLend) return

            if (lend.edit !== oldLend.edit) return
            // 納品場所が変わった場合
            if (lend.deliveryLocation !== oldLend.deliveryLocation) {
              this.setRowEdit(index, rowIndex, true)
              return
            }

            // 貸出しチェックボックスが変わった場合
            if (lend.lendFlag !== oldLend.lendFlag) {
              this.setRowEdit(index, rowIndex, false)
            }
          })
        })
      }
    }
  } **/
}
</script>
<style>
.active-list {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
}
.list-type {
  padding: 0.5rem;
  color: #fefefe;
}
.list-type:hover {
  color: #fefefe;
  cursor: pointer;
}
.active-list:hover {
  background-color: #CACFEC;
  color: rgb(22, 28, 61);
  cursor: default;
  text-decoration: none;
}
.th-head {
  background-color: #cacfec !important;
  border: 1px solid #dee2e6 !important;
  color: #000000;
  font-weight: normal;
}

.th-cell {
  background-color: #FFFFFF !important;
  border: 1px solid #eefdff !important;
  color: #000000;
  font-weight: normal;
}

.white-line {
  background-color: #fff;
}
.white-line:hover {
  background-color: #d9efff !important;
}
.gray-line {
  background-color: #eefdff;
}
.gray-line:hover {
  background-color: #d9efff !important;
}
.disabled-line {
  background-color: #BFC5CA;
}
.tile-image-height {
  max-height: 140px;
  height: auto;
}

.star input[type='checkbox']{
  display: none;
}
.star label{
  color: #D2D2D2;
  font-size: 30px;
  cursor: pointer;
}
.star input[type='checkbox']:checked ~ label{
  color: #F8C601;
}
.no-pointer-events {
  Pointer-events: none;
}

.image-box {
  cursor: zoom-in !important;
  display: inline-block !important;
  padding: 0px !important;
  background-color: #FFF !important;
  border-color: #FFF !important;
}

.no-spin::-webkit-inner-spin-button,
.no-spin::-webkit-outer-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
    -moz-appearance:textfield !important;
}

.fixed-header-table thead th {
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
}
</style>



// WEBPACK FOOTER //
// src/pages/MaterialsAndEquipmentAdjustmentList.vue